import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import * as ROUTES from '../constants/routes';

const useLocationConfig = (screens) => {
  const location = useLocation();
  const [locationConfig, setLocationConfig] = useState(null);

  useEffect(() => {
    const config = getRouteMapping(location.pathname, screens);
    setLocationConfig(config);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  return locationConfig;
};

const getRouteMapping = (findPath, screens) => {
  if (typeof ROUTES !== 'object' || typeof findPath !== 'string' || findPath === '/') return null;
  const pathPair = Object.entries(ROUTES).find(([key, value]) => findPath === value);
  if (!Array.isArray(pathPair) || typeof pathPair[0] !== 'string') return null;
  return screens[pathPair[0]];
};

export default useLocationConfig;
